import type { Translation } from "./en";
import tasksUz from "./uz.tasks";
import bugsUz from "./uz.bugs";
import notifyUz from "./uz.notify";
import analyticsUz from "./uz.analytics";
import workUz from "./uz.work";
import sprintsUz from "./uz.sprints";

const uz: Translation = {
  ...tasksUz,
  ...bugsUz,
  ...notifyUz,
  ...analyticsUz,
  ...workUz,
  ...sprintsUz,
  editor: {
    formatting: "Formatlash",
    bold: "Qalin",
    italic: "Kursiv",
    strike: "Ustidan chizilgan",
    code: "Kod",
    link: "Havola",
    linkAddress: "Havola manzili",
    apply: "Qo‘llash",
    bulletList: "Belgili ro‘yxat",
    orderedList: "Raqamli ro‘yxat",
    taskList: "Nazorat ro‘yxati",
    quote: "Iqtibos",
    codeBlock: "Kod bloki",
  },
  common: {
    bot: "bot",
    botHint: "Integratsiya hisobi (bot), odam emas",
    dismiss: "Yopish",
    clear: "Tozalash",
    more: "Boshqa amallar",
    save: "Saqlash",
    add: "Qo‘shish",
    delete: "O‘chirish",
    saving: "Saqlanmoqda…",
    cancel: "Bekor qilish",
    close: "Yopish",
    create: "Yaratish",
    edit: "Tahrirlash",
    remove: "Olib tashlash",
    copy: "Nusxalash",
    copied: "Nusxalandi",
    download: "Yuklab olish",
    loading: "Yuklanmoqda…",
    continue: "Davom etish",
    back: "Orqaga",
    all: "Hammasi",
    optional: "ixtiyoriy",
    actions: "Amallar",
    never: "Hech qachon",
    retry: "Qayta urinish",
    loadFailed: "Yuklab bo‘lmadi. Internet aloqasini tekshirib, qayta urinib ko‘ring.",
  },
  viewer: {
    zoomIn: "Kattalashtirish",
    zoomOut: "Kichiklashtirish",
    fit: "Ekranga moslash",
    previous: "Oldingi",
    next: "Keyingi",
    openOriginal: "Asl faylni ochish",
    counter: "{{n}} / {{total}}",
    hint: "G‘ildirak yoki ikki barmoq — masshtab · sudrash — siljitish · ikki marta bosish — yaqinlashtirish yoki uzoqlashtirish · ← → — varaqlash",
  },
  combobox: {
    create: "«{{value}}» yaratish",
  },
  roles: {
    manager: "Menejer",
    developer: "Dasturchi",
    tester: "Tester",
    viewer: "Kuzatuvchi",
  },
  locales: {
    en: "English",
    uz: "O‘zbekcha",
    ru: "Русский",
  },
  theme: {
    light: "Yorug‘",
    dark: "Qorong‘i",
    system: "Tizim",
  },
  errors: {
    unauthorized: "Sessiya tugadi. Iltimos, qaytadan kiring.",
    forbidden: "Bu amal uchun ruxsatingiz yo‘q.",
    csrf: "So‘rov xavfsizlik sababli bloklandi. Sahifani yangilab, qayta urinib ko‘ring.",
    not_found: "Topilmadi.",
    validation: "Ba’zi maydonlar noto‘g‘ri. Tekshirib, qayta urinib ko‘ring.",
    conflict: "Bunday yozuv allaqachon mavjud.",
    invalid_credentials: "Login yoki parol noto‘g‘ri.",
    account_locked: "Juda ko‘p muvaffaqiyatsiz urinish. Hisob 15 daqiqaga bloklandi.",
    account_disabled: "Bu hisob o‘chirilgan. Menejerga murojaat qiling.",
    invalid_code: "Kod noto‘g‘ri. Tekshirib, qayta urinib ko‘ring.",
    owner_protected: "Egasi hisobini faqat egasining o‘zi o‘zgartira oladi.",
    storage_unavailable: "Fayl ombori hozir ishlamayapti. Keyinroq urinib ko‘ring.",
    internal: "Bizda nimadir xato ketdi. Qayta urinib ko‘ring.",
    network: "Serverga ulanib bo‘lmadi. Internet aloqasini tekshiring.",
  },
  auth: {
    signInTitle: "Mixla tizimiga kirish",
    signInHint: "Menejeringiz bergan login va paroldan foydalaning.",
    username: "Login",
    password: "Parol",
    signIn: "Kirish",
    language: "Til",
    steps: {
      password: "Parol",
      authenticator: "Autentifikator",
      recovery: "Tiklash kodlari",
    },
    verifyTitle: "Ikki bosqichli autentifikatsiya",
    verifyHint: "Autentifikator ilovasidagi 6 xonali kodni kiriting.",
    useRecovery: "Uning o‘rniga tiklash kodidan foydalanish",
    useAuthenticator: "Autentifikator ilovasidan foydalanish",
    recoveryLabel: "Tiklash kodi",
    recoveryHint: "Har bir tiklash kodi faqat bir marta ishlaydi.",
    verify: "Tasdiqlash",
    otherAccount: "Boshqa hisob bilan kirish",
    setupTitle: "Ikki bosqichli autentifikatsiyani sozlang",
    setupHint: "Barcha hisoblar uchun majburiy. Kodni Google Authenticator, 1Password yoki istalgan TOTP ilovasi bilan skanerlang.",
    cantScan: "Skanerlab bo‘lmadimi? Ushbu kalitni kiriting",
    copyKey: "Kalitni nusxalash",
    enterCode: "6 xonali kodni kiriting",
    verifyAndContinue: "Tasdiqlash va davom etish",
    qrLabel: "Autentifikator ilovasi uchun QR kod",
    recoveryTitle: "Tiklash kodlarini saqlab qo‘ying",
    recoveryIntro:
      "Telefoningizni yo‘qotsangiz, har bir kod bilan bir marta kirishingiz mumkin. Ularni xavfsiz joyda saqlang — ular qayta ko‘rsatilmaydi.",
    copyAll: "Hammasini nusxalash",
    downloadTxt: ".txt yuklab olish",
    savedCheckbox: "Kodlarni saqlab qo‘ydim",
    finish: "Mixlaga o‘tish",
    digit: "{{n}}-raqam (6 tadan)",
    recoveryFileHeader: "{{username}} uchun Mixla tiklash kodlari. Har bir kod bir marta ishlaydi.",
  },
  nav: {
    apiDocs: "API hujjatlari",
    main: "Asosiy",
    projects: "Loyihalar",
    inbox: "Kiruvchilar",
    tasks: "Vazifalar",
    project: "Loyiha",
    overview: "Umumiy",
    planning: "Rejalashtirish",
    reports: "Hisobotlar",
    members: "A’zolar",
    settings: "Sozlamalar",
    admin: "Boshqaruv",
    users: "Foydalanuvchilar",
    profile: "Profil",
    switchProject: "Loyihani almashtirish",
    allProjects: "Barcha loyihalar",
    noProjects: "Hali loyihalar yo‘q",
    openMenu: "Menyuni ochish",
  },
  projects: {
    title: "Loyihalar",
    newProject: "Yangi loyiha",
    showArchived: "Arxivdagilarni ko‘rsatish",
    emptyTitle: "Hali loyihalar yo‘q",
    emptyManager: "Birinchi loyihani yarating, so‘ng unga odamlarni qo‘shing.",
    emptyMember: "Siz hali hech qaysi loyihada emassiz. Menejerdan sizni qo‘shishini so‘rang.",
    archived: "Arxivlangan",
    membersCount: "A’zolar: {{count}}",
    yourRole: "Sizning rolingiz",
    key: "Kalit",
    keyHint: "2–10 belgi: bosh harflar va raqamlar, harf bilan boshlanadi. Vazifa kalitlari shu bilan boshlanadi (PAY-12). Keyin o‘zgartirib bo‘lmaydi.",
    name: "Nomi",
    description: "Tavsif",
    created: "Loyiha yaratildi",
  },
  overview: {
    majorBugs: "Ochiq S1/S2 xatolar",
    openBugs: "Jami ochiq xatolar: {{count}}",
    overdueBugs: "Kechikkan xatolar",
    toTest: "Sinash kerak",
    toFix: "Tuzatish kerak",
    openTasks: "Ochiq vazifalar",
    overdueTasks: "Muddati o‘tgan vazifalar",
    bugsTitle: "E’tibor talab qiladigan xatolar",
    allBugs: "Barcha xatolar",
    tasksTitle: "Kutayotgan vazifalar",
    allTasks: "Barcha vazifalar",
    peopleTitle: "Kimda nima bor",
    roundsTitle: "Shu haftadagi sinov raundlari",
    noOpenBugs: "Ochiq xato yo‘q.",
    nothingWaiting: "Hech narsa kutmayapti.",
    noRounds: "Oxirgi 7 kunda yakunlangan raund yo‘q.",
    person: "Xodim",
    bugsOwned: "Xatolar",
    longestWait: "Eng uzoq kutish",
    noDescription: "Hali tavsif yo‘q.",
    archivedNotice: "Bu loyiha arxivlangan. Menejer uni arxivdan chiqarmaguncha loyihalar ro‘yxatida ko‘rinmaydi.",
  },
  members: {
    title: "A’zolar",
    add: "A’zo qo‘shish",
    user: "Foydalanuvchi",
    platformRole: "Platformadagi rol",
    projectRole: "Ushbu loyihadagi rol",
    sameAsPlatform: "Platformadagi rol bilan bir xil",
    removeTitle: "{{name}} {{project}} loyihasidan olib tashlansinmi?",
    removeBody: "U bu loyihaga kira olmaydi. Tarixi saqlanib qoladi.",
    added: "A’zo qo‘shildi",
    removed: "A’zo olib tashlandi",
    updated: "Rol yangilandi",
    empty: "Hali a’zolar yo‘q.",
    readOnly: "A’zolarni faqat loyiha menejerlari o‘zgartira oladi.",
    noUsersLeft: "Hamma allaqachon a’zo.",
    disabled: "O‘chirilgan",
    managerAlways: "Platforma menejerlari barcha loyihalarda menejer hisoblanadi.",
    pickUser: "Foydalanuvchini tanlang",
  },
  settings: {
    title: "Loyiha sozlamalari",
    general: "Umumiy",
    workflow: "Ish jarayoni",
    templates: "Shablonlar",
    logo: "Logotip",
    logoHint: "PNG, JPEG yoki WebP, 2 MB gacha.",
    uploadLogo: "Logotip yuklash",
    replaceLogo: "Almashtirish",
    removeLogo: "Logotipni olib tashlash",
    uploading: "Yuklanmoqda…",
    logoUploaded: "Logotip yangilandi",
    logoRemoved: "Logotip olib tashlandi",
    logoTooBig: "Fayl 2 MB dan katta.",
    logoBadType: "PNG, JPEG yoki WebP rasmdan foydalaning.",
    saved: "Sozlamalar saqlandi",
    archiveSection: "Arxiv",
    archiveBody:
      "Arxivlangan loyihalar ro‘yxatda ko‘rinmaydi. Istalgan vaqtda arxivdan chiqarish mumkin; hech narsa o‘chirilmaydi.",
    archive: "Loyihani arxivlash",
    unarchive: "Arxivdan chiqarish",
    archiveTitle: "{{name}} arxivlansinmi?",
    archivedToast: "Loyiha arxivlandi",
    unarchivedToast: "Loyiha arxivdan chiqarildi",
    forbidden: "Sozlamalarni faqat loyiha menejerlari o‘zgartira oladi.",
  },
  users: {
    title: "Foydalanuvchilar",
    newUser: "Yangi foydalanuvchi",
    filterRole: "Rol",
    filterStatus: "Holat",
    allRoles: "Barcha rollar",
    allStatuses: "Barcha holatlar",
    active: "Faol",
    disabled: "O‘chirilgan",
    name: "Ism",
    username: "Login",
    role: "Rol",
    twoFactor: "2FA",
    status: "Holat",
    projects: "Loyihalar",
    lastLogin: "Oxirgi kirish",
    twoFactorOn: "Sozlangan",
    twoFactorOff: "Hali yo‘q",
    owner: "Egasi",
    you: "siz",
    reset: "Parol va 2FA ni tiklash",
    resetTitle: "{{name}} uchun parol va 2FA tiklansinmi?",
    resetBody:
      "Yangi parol yaratiladi, ikki bosqichli autentifikatsiya o‘chiriladi va barcha sessiyalari yopiladi. Keyingi kirishda 2FA ni qayta sozlaydi.",
    resetConfirm: "Tiklash",
    createTitle: "Yangi foydalanuvchi",
    displayName: "Ko‘rsatiladigan ism",
    usernameHint: "Kichik harflar, raqamlar, nuqta, chiziqcha va pastki chiziq.",
    language: "Til",
    projectsLabel: "Loyihalar",
    projectsHint: "Foydalanuvchi qo‘shiladigan loyihalarni belgilang. Loyihada boshqa rol berishingiz mumkin.",
    noProjectsYet: "Hali loyihalar yo‘q — foydalanuvchini keyinroq qo‘shishingiz mumkin.",
    roleInProject: "Loyihadagi rol",
    createButton: "Foydalanuvchi yaratish",
    created: "Foydalanuvchi yaratildi",
    passwordTitle: "{{username}} uchun parol",
    passwordWarning: "Hozir nusxalang va xavfsiz yo‘l bilan yuboring. U qayta ko‘rsatilmaydi.",
    passwordNext: "Birinchi kirishda u ikki bosqichli autentifikatsiyani sozlaydi.",
    done: "Tayyor",
    editTitle: "{{name}} ni tahrirlash",
    accountDisabled: "Hisob o‘chirilgan",
    accountDisabledHint: "O‘chirilgan foydalanuvchilar tizimga kira olmaydi. Tarixi saqlanib qoladi.",
    saved: "Foydalanuvchi saqlandi",
    resetDone: "Parol va 2FA tiklandi",
    empty: "Bu filtrlarga mos foydalanuvchi yo‘q.",
    ownerLocked: "Egasi hisobini faqat egasining o‘zi o‘zgartira oladi.",
    newBot: "Yangi bot",
    filterKind: "Turi",
    allKinds: "Hammasi",
    people: "Odamlar",
    bots: "Botlar",
    access: "Kirish",
    lastActive: "Oxirgi faollik",
    tokenCount: "Tokenlar: {{count}}",
    tokens: "Tokenlar",
    createBotTitle: "Yangi bot",
    createBotButton: "Bot yaratish",
    botCreated: "Bot yaratildi",
    botIntro: "Bot — integratsiya uchun hisob (CI, deploy skriptlari, monitoring). Unda odamdek rol va loyihalar bor, lekin parol yo‘q: u faqat siz yaratgan API tokenlar orqali ishlaydi.",
    botTokensTitle: "{{name}} tokenlari",
    botTokensIntro: "Bu tokenlardan foydalangan har qanday tizim @{{username}} nomidan, uning roli va loyihalari bilan ishlaydi. Ularni paroldek saqlang.",
    botDisabledTokens: "Bot o‘chirilgan: qayta yoqmaguningizcha tokenlari ishlamaydi.",
  },
  profile: {
    title: "Profil",
    account: "Hisob",
    displayName: "Ko‘rsatiladigan ism",
    username: "Login",
    role: "Platformadagi rol",
    preferences: "Sozlamalar",
    language: "Til",
    theme: "Mavzu",
    saved: "Profil saqlandi",
    changePassword: "Parolni o‘zgartirish",
    currentPassword: "Joriy parol",
    newPassword: "Yangi parol",
    confirmPassword: "Yangi parolni takrorlang",
    passwordHint: "Kamida 12 ta belgi.",
    passwordMismatch: "Parollar mos kelmadi.",
    passwordTooShort: "Kamida 12 ta belgidan foydalaning.",
    passwordChanged: "Parol o‘zgartirildi",
    security: "Xavfsizlik",
    sessions: "Sessiyalar",
    logoutOthers: "Boshqa barcha qurilmalardan chiqish",
    logoutOthersHint: "Boshqa barcha brauzer va qurilmalardagi sessiyalar yopiladi. Bu sessiya ochiq qoladi.",
    loggedOutOthers: "Boshqa sessiyalar yopildi",
    logout: "Chiqish",
  },
  notFound: {
    title: "Sahifa topilmadi",
    body: "Bunday sahifa yo‘q yoki unga kirish huquqingiz yo‘q.",
    home: "Loyihalarga o‘tish",
  },
};

export default uz;
